import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'

interface DownloadProtocolParams {
  flatId: string
  protocolId: string
  protocolName?: string
}

export function useDownloadProtocol() {
  const downloadProtocol = async ({
    flatId,
    protocolId
  }: DownloadProtocolParams) => {
    const response = await apiClient.get(
      `${SNA_PREFIX}flats/${flatId}/protocols/${protocolId}`,
      {
        responseType: 'blob'
      }
    )
    const blob = response.data
    const fileURL = URL.createObjectURL(blob)
    window.open(fileURL, '_blank')
  }

  return { downloadProtocol }
}
